export default "__VITE_ASSET__D_g8t6aM__"